import _ from "underscore";
import Raven from "raven-js";

import { CAMPAIGNS_ENDPOINT } from "api/base";
import ChannelModel from "../model/channel";
import BrandModel from "../model/brand";
import EventModel from "../model/event";
import GalleryModel from "../model/gallery";
import BaseCollection from "./base";

export function contextModelConstructor(attrs) {
    if (attrs.channelId !== undefined || attrs.type === `channel`) {
        return ChannelModel;
    }
    if (attrs.brandId !== undefined || attrs.type === `brand`) {
        return BrandModel;
    }
    if (attrs.eventId !== undefined || attrs.type === `event`) {
        return EventModel;
    }
    if (attrs.galleryId !== undefined || attrs.type === `gallery`) {
        return GalleryModel;
    }
}

var ContextCollection = BaseCollection.extend({
    constants: {
        STATUS: {
            ACTIVE: `active`,
            ARCHIVED: `archived`
        }
    },

    url: function () {
        var params = {
            pageSize: 1000
        };

        if (!_.isUndefined(this.userId)) {
            params.userId = this.userId;
        }

        if (!_.isUndefined(this.extended)) {
            params.extended = this.extended;
        }

        return `${CAMPAIGNS_ENDPOINT}?${$.param(params)}`;
    },

    initialize: function (models, options) {
        options = _.isObject(options) ? options : {};

        if (!_.isUndefined(options.organizationId)) {
            this.organizationId = options.organizationId;
        }
        if (!_.isUndefined(options.userId)) {
            this.userId = options.userId;
        }
        if (!_.isUndefined(options.extended)) {
            this.extended = options.extended;
        }

        _.bindAll(this, `isActive`, `isArchived`);
    },

    /**
     * Polymorphic backbone collection
     * Check: http://backbonejs.org/#Collection-model
     */
    model: function (attrs, options) {
        return new (contextModelConstructor(attrs))(attrs, options);
    },

    modelId: function (attrs) {
        if (attrs.channelId !== undefined) {
            return attrs.channelId;
        }
        if (attrs.brandId !== undefined) {
            return attrs.brandId;
        }
        if (attrs.eventId !== undefined) {
            return attrs.eventId;
        }
        if (attrs.galleryId !== undefined) {
            return attrs.galleryId;
        }
        if (attrs.contextId !== undefined) {
            return attrs.contextId.split(`:`)[0];
        }
    },

    parse: function (response) {
        // Weird conditions because if we fetch the data from the API
        // if doenst have the same format as if we construct them in the JSP
        var ctxs =
            response.campaigns !== undefined ? response.campaigns : response;
        // Using the versioned api we want to check if there's a data object which contains the campaign details
        ctxs = response.data !== undefined ? response.data : ctxs;

        var contexts = ctxs
            .filter(function (context) {
                var contextExists = !_.isUndefined(
                    context[context.contextId.split(`:`)[0]]
                );
                if (contextExists) {
                    return true;
                } else {
                    if (typeof window !== `undefined` && window.Raven) {
                        Raven.captureMessage(
                            `Wrong ACL configuration for: ${context.contextId}`,
                            {
                                level: `error` // one of 'info', 'warning', or 'error'
                            }
                        );
                    } else {
                        console.error(
                            `Wrong ACL configuration for: ${context.contextId}`
                        );
                    }
                    return false;
                }
            })
            .map(function (context) {
                // ContextId = gallery:XXXXXXX
                // The first part give us the key to get
                // the actual model content
                var ctx = context[context.contextId.split(`:`)[0]];
                return contextModelConstructor(ctx).prototype.parse(ctx);
            });

        return contexts;
    },

    comparator: function (a, b) {
        return a.get(`name`).toLowerCase() > b.get(`name`).toLowerCase()
            ? 1
            : -1;
    },

    search: function (query) {
        return _(
            ContextCollection.__super__.search
                .call(this, `name`, query)
                .filter(this.isActive)
        );
    },

    getActiveContexts: function () {
        return _(this.filter(this.isActive));
    },

    getArchivedContexts: function () {
        return _(this.filter(this.isArchived));
    },

    isActive: function (context) {
        return context.get(`status`) === this.constants.STATUS.ACTIVE;
    },

    isArchived: function (context) {
        return context.get(`status`) === this.constants.STATUS.ARCHIVED;
    },

    pluckDisplayNames: function () {
        var displayNames = [];
        _.each(this, function (model) {
            displayNames.push(model.getDisplayName());
        });
        return displayNames;
    },

    getByCompoundId: function (compoundId) {
        compoundId = _.isString(compoundId) ? compoundId : ``;
        var id = compoundId.split(`:`)[1];
        return this.get(id);
    }
});

export default ContextCollection;
